import styled, { css } from 'styled-components';
import { unit, pxToRem } from 'modules/spacing';
import { themeGet, interactiveTransition } from 'modules/tetrisTheme';
import { formLabel } from 'modules/theme';
const containerSize = {
    small: 4,
    large: 6,
};
export const Container = styled.div `
  display: flex;
  align-items: center;
  gap: ${themeGet('spacing.md')};
`;
export const InputContainer = styled.div `
  flex-shrink: 0;
  display: inline-block;
  position: relative;
  width: ${(props) => unit(containerSize[props.$size])};
  height: ${(props) => unit(containerSize[props.$size])};
`;
export const Overlay = styled.div `
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  pointer-events: none;
  inset: 0;
  border: ${pxToRem(1)} solid ${themeGet('colors.border.200')};

  & svg {
    color: ${themeGet('colors.primary.0')};
  }

  background-color: ${themeGet('colors.primary.0')};
  border-color: ${(props) => props.$invalid && themeGet('colors.red.500')};
  box-shadow: 0 0 0 ${unit(0.5)} transparent;
  ${interactiveTransition};
`;
const checkedStyles = css `
  &:checked + div {
    & svg {
      color: ${themeGet('colors.primary.0')};
    }

    background-color: ${(props) => (props.$invalid ? themeGet('colors.red.400') : themeGet('colors.primary.1000'))};
    border-color: ${(props) => (props.$invalid ? themeGet('colors.red.500') : themeGet('colors.primary.800'))};
    box-shadow: 0 0 0 ${unit(0.5)} transparent;
  }
`;
const indeterminateStyles = css `
  &:indeterminate:not([type='radio'], :disabled) + div {
    & svg {
      color: ${themeGet('colors.primary.0')};
    }

    background-color: ${(props) => (props.$invalid ? themeGet('colors.red.400') : themeGet('colors.primary.1000'))};
    border-color: ${(props) => (props.$invalid ? themeGet('colors.red.500') : themeGet('colors.primary.800'))};
    box-shadow: 0 0 0 ${unit(0.5)} transparent;
  }
`;
const hoverStyles = css `
  &:not(:disabled):hover + div {
    filter: brightness(0.9);
  }
`;
const focusStyles = css `
  &:not(:disabled):focus-visible + div {
    & svg {
      color: ${themeGet('colors.primary.0')};
    }

    background-color: ${themeGet('colors.primary.0')};
    border-color: ${(props) => (props.$invalid ? themeGet('colors.red.500') : themeGet('colors.primary.600'))};
    box-shadow: 0 0 0 ${unit(0.5)} ${themeGet('colors.focus.primary')};
  }

  &:not(:disabled):focus-visible:checked + div {
    background-color: ${(props) => (props.$invalid ? themeGet('colors.red.400') : themeGet('colors.primary.1000'))};
  }
`;
const activeStyles = css `
  &:not(:disabled):active + div {
    & svg {
      color: ${themeGet('colors.primary.800')};
    }

    background-color: ${themeGet('colors.primary.50')};
    border-color: ${themeGet('colors.primary.1000')};
    box-shadow: 0 0 0 ${unit(0.5)} transparent;
  }
`;
const disabledStyles = css `
  &:disabled + div {
    & svg {
      color: ${themeGet('colors.disabled.100')};
    }

    background-color: ${themeGet('colors.disabled.100')};
    border-color: ${themeGet('colors.disabled.200')};
    box-shadow: 0 0 0 ${unit(0.5)} transparent;
  }

  &:disabled:checked + div {
    & svg {
      color: ${themeGet('colors.disabled.200')};
    }
  }
`;
export const Input = styled.input `
  position: absolute;
  margin: 0;
  width: 100%;
  height: 100%;
  border: 0;
  appearance: none;
  opacity: 0;

  :focus-visible {
    outline: none;
  }

  ${checkedStyles};
  ${indeterminateStyles};
  ${hoverStyles};
  ${activeStyles};
  ${focusStyles};
  ${disabledStyles};
`;
export const Label = styled.label `
  ${formLabel};
  overflow-wrap: break-word;
  overflow: hidden;
`;
